<template>
  <div>
    <van-tabbar v-model="tabbarActive">
      <van-tabbar-item icon="comment-o" replace to="/ticket-vue/my">工单</van-tabbar-item>
      <van-tabbar-item icon="apps-o" replace to="/ticket-vue/view-list">视图</van-tabbar-item>
      <van-tabbar-item icon="add-o" replace to="/ticket-vue/n2">新增</van-tabbar-item>
      <van-tabbar-item icon="volume-o" replace to="/ticket-vue/event">动态</van-tabbar-item>
      <van-tabbar-item icon="user-o" replace to="/ticket-vue/me">我</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
    name : "MobileTicketTabbar",

    props : ['active'],

    data() {
      return {
        tabbarActive : null
      }
    },

    mounted() {
      this.tabbarActive = this.active;
    },

    watch : {
      active() {
        this.tabbarActive = this.active;
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketTabbar.vue